import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwMetaDataListCardConfigData } from '@devwareapps/devware-cap';

import { AppMetaDataItemNames } from '../../../../../meta-data/app-meta-data.service';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'No-Assignments-Card-Redesign',
  key: 'noAssignmentsCardRedesign',
  componentType: DwComponentType.card,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Assignment,
  configData: {
  }
})
@Component({
  selector: 'app-no-assignments-card-redesign',
  templateUrl: './no-assignments-card-redesign.component.html',
  styleUrls: ['./no-assignments-card-redesign.component.scss']
})
export class NoAssignmentsCardRedesignComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }
}
